module.exports = __webpack_public_path__ + "img/生产成本急剧上升.becb031b.png";